import * as types from "../../addressMultiple/store/addressMultiple.actionType";
import * as commonActionType from "@common/store/common/common.actionsType";
import Immutable from "seamless-immutable";

// const initialState = Immutable({
//     Cep: undefined,
//     Uf: undefined,
//     Cidade: undefined,
//     Logradouro: undefined,
//     Tipo: undefined,
//     Bairro: undefined,
//     Numero: undefined,
//     Complemento: undefined,
//     TipoFiltro: 1
//   });

const initialState = {};

export default function reduce(state = initialState, action = {}) {
  let payload = action.payload || {};
  switch (action.type) {
    case types.ADDRESS_MULTIPLE_SET:
      return { ...state, [payload.hash]: { ...state[payload.hash], ...payload.state } };
    case types.ADDRESS_MULTIPLE_HASH_SET:
      return { ...state, hash: payload };

    case types.ADDRESS_MULTIPLE_FILTERTYPE_SET:
      return { ...state, [state.hash]: { ...state[state.hash], TipoFiltro: payload } };

    // case types.ADDRESS_MULTIPLE_RESET:
    //   return state.merge(initialState);

    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
}
